import styled from 'styled-components'
import { WallBackground } from './../WallBackground/theme'

export const MeasureOpacity = styled(WallBackground)`
  z-index: 2;
  background: rgba(0, 0, 0, 0.7);
  display: ${props => (props.isCalibrationNow ? 'block' : 'none')};
  width: 100%;
  position: absolute;
  left: unset;
`

export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 20%;
  width: ${props => props.nonInteractive? '100%':(props.sidebar ? '100%' : `calc(100% - ${props.theme.sidebar.width})`)};

  display: flex;
  align-items: center;
  justify-content: center;
`

export const AcceptButton = styled.button`
  background: ${props => props.theme.colors.primary};
  border: none;
  padding: 10px;
  border-radius: 6px;
  color: ${props => props.theme.colors.white};

  :hover {
    cursor: pointer;
  }
  :disabled {
    opacity: 0.6;
  }

  & + & {
    margin-left: 30px;
  }
`

export const Text = styled.span`
  position: absolute;
  bottom: 30%;
  display: block;
  width: ${props => props.nonInteractive? '100%':(props.sidebar ? '100%' : `calc(100% - ${props.theme.sidebar.width})`)};
  text-align: center;
  font-size: 14px;
  color: white;
`

export const Highlighted = styled.span`
  color: ${props => props.theme.colors.primary};
`



// WEBPACK FOOTER //
// ./src/components/MeasureBackground/theme.js